import {all, fork, select, takeLatest} from 'redux-saga/effects';
import LightboxActions from "./actions";
import pdfPreview from "./onCurrentIndexChange/pdfPreview";
import fileManager from "./onCurrentIndexChange/fileManager";
import bukkuUpload from "./onCurrentIndexChange/bukkuUpload";
import panelOtherFileList from "./onCurrentIndexChange/panelOtherFileList";
import {LightboxType} from "./options";
import {message} from "antd";

function* onCurrentIndexChangeSaga() {
    yield takeLatest([
        LightboxActions.LIGHTBOX_OPEN,
        LightboxActions.LIGHTBOX_SET_CURRENT_INDEX,
    ], function* (action) {
        try {
            const { lightboxType } = yield select(state => state.Lightbox);

            switch (lightboxType) {
                case LightboxType.pdf_preview:
                    return yield pdfPreview(action);
                case LightboxType.file_manager:
                    return yield fileManager(action, false);
                case LightboxType.bukku_upload:
                    return yield bukkuUpload(action);
                case LightboxType.TRANSACTION:
                case LightboxType.CONTACT:
                    return yield panelOtherFileList(action);
                default:
                    return null;
            }
        }
        catch (error) {
            console.error('qq', error);
            yield message.error(error.message);
        }
        return null;
    });
}

export default function* rootSaga() {
    yield all([
        fork(onCurrentIndexChangeSaga),
    ]);
}
